//Hooks
import { get } from 'svelte/store';
//Helpers
import {
	isProThreeEM,
	isPill,
	isShellyPresence,
	isEMWithoutSwitch,
} from 'src/helpers/interface_helpers';
import {
	getComponentIdByDeviceChannel,
	isCombinationDeviceLightMode,
} from '../core/local_action_components_helpers';
import { getMainDeviceForLocalActions } from '../core/local_action_device_helpers';
// Stores
import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

const supportsSwitchLocalActions = (device: Device): boolean => {
	// EM devices without switch/relay should not support local actions
	if (isEMWithoutSwitch(device.type)) return false;
	let hasLocalActions = !/^(sensor|power_meter|inputs_reader|thermostat|gateway)$/.test(
		device.category,
	);
	if (isProThreeEM(device.type)) {
		const status = devices_status.getByRealId(device.id);
		if (!status?.['switch:100']) hasLocalActions = false;
	}
	return (
		isPill(device.type) ||
		isShellyPresence(device.type) ||
		/^(SBTR-001AEU|SHTRV-01|S3XT-0S|S3PL-30116EU)$/.test(device.type) ||
		hasLocalActions
	);
};

export const doesSupportSwitchLocalActions = (device: Device): boolean => {
	const mainDevice = getMainDeviceForLocalActions(device, get(devices));
	return mainDevice ? supportsSwitchLocalActions(mainDevice) : false;
};

export const doesSupportLocalActions = (device: Device): boolean => {
	const mainDevice = getMainDeviceForLocalActions(device, get(devices));
	if (!mainDevice) return false;
	if (supportsSwitchLocalActions(mainDevice)) return true;
	return Object.keys(devices_settings.getByRealId(mainDevice.id) || {}).some((key) =>
		/^lnm:\d+$/.test(key),
	);
};

export const isSupportedMethodByChannel = (
	device: Device,
	job: ActionJob,
	deviceChannel: number,
): boolean => {
	if (!isCombinationDeviceLightMode(device)) {
		return job?.params?.id == deviceChannel;
	}
	deviceChannel = getComponentIdByDeviceChannel(device);
	const method = (job?.method || '').toLowerCase();
	return job?.params?.id == deviceChannel && RegExp(`^${device.mode}\.`).test(method);
};
